export const AboutSuperbet = {
    AboutUs: 'AboutUs',
    AboutUsBelgium: 'AboutUsBelgium',
    Agencies: 'Agencies',
    Help: 'Help',
    DataProtection: 'DataProtection',
    CookiePolicy: 'CookiePolicy',
    ResponsibleGaming: 'ResponsibleGaming',
    AntiLaunderingPolicy: 'AntiLaunderingPolicy',
    GameRules: 'GameRules',
    TermsAndConditions: 'TermsAndConditions',
    Careers: 'Careers',
    CareersBelgium: 'CareersBelgium',
    Cooperation: 'Cooperation',
    PressOffice: 'PressOffice',
    PrivacyPolicy: 'PrivacyPolicy',
    AbcPlayer: 'AbcPlayer',
    BettingRules: 'BettingRules',
    BettingAndGameRules: 'BettingAndGameRules',
    ComplaintsProcedure: 'ComplaintsProcedure',
    GrandCasinoKnokke: 'GrandCasinoKnokke',
    GamingHalls: 'GamingHalls',
    License: 'License',
    LicenseBrazil: 'LicenseBrazil',
    AuthorizationDecision: 'AuthorizationDecision',
    Redaction: 'Redaction',
    Marketing: 'Marketing',
    CustomerSupport: 'CustomerSupport',
} as const;

export type AboutSuperbet = typeof AboutSuperbet[keyof typeof AboutSuperbet];

export type AboutSuperbetLinkType =
    | 'static'
    | 'external'
    | 'route';

export type AboutSuperbetLink = {
    label: string;
    type: AboutSuperbetLinkType;
    e2e: string;
    path?: string;
    routeName?: string;
    dynamic?: boolean;
};
